import { render, staticRenderFns } from "./button_group.vue?vue&type=template&id=5681cdbb&scoped=true"
import script from "./button_group.vue?vue&type=script&lang=ts"
export * from "./button_group.vue?vue&type=script&lang=ts"
import style0 from "./button_group.vue?vue&type=style&index=0&id=5681cdbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5681cdbb",
  null
  
)

export default component.exports